export const educationData = [
    {
        id: 1,
        institution: 'Roots International Schools & Colleges, Islamabad',
        course: 'High School / Matriculation',
        startYear: '2008',
        endYear: '2018'
    },
    {
        id: 2,
        institution: 'Punjab College of Information Technology, Rawalpindi',
        course: 'F.Sc - Pre-Engineering',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Capital University of Science and Technology, Islamabad',
        course: 'Bachelor of Science in Software Engineering',
        startYear: '2020',
        endYear: '2024'
    },
]